(function () {
  document.querySelectorAll('.tpc-collection-upsell').forEach(function (section) {
    initTPCCollectionUpsell(section);
  });

  function initTPCCollectionUpsell(section) {

    /* ===== Add to Cart (AJAX) — reuses tpc-shop pattern ===== */
    var addButtons = section.querySelectorAll(
      '.tpc-cu__featured-cta, .tpc-cu__small-add'
    );

    addButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;

        /* Check if product has multiple variants — open variant modal */
        var card = btn.closest('[data-variants-count]');
        var variantsCount = card ? parseInt(card.getAttribute('data-variants-count') || '1', 10) : 1;
        var productUrl = card ? card.getAttribute('data-product-url') : null;

        if (variantsCount > 1) {
          var dataScript = card ? card.querySelector('.tpc-vm-product-data') : null;
          if (dataScript && window.TPCVariantModal) {
            window.TPCVariantModal.open(JSON.parse(dataScript.textContent), btn);
          } else if (productUrl) {
            window.location.href = productUrl;
          }
          return;
        }

        /* Single variant — add directly to cart */
        var isFeatured = btn.classList.contains('tpc-cu__featured-cta');
        var addingClass = isFeatured
          ? 'tpc-cu__featured-cta--adding'
          : 'tpc-cu__small-add--adding';
        var addedClass = isFeatured
          ? 'tpc-cu__featured-cta--added'
          : 'tpc-cu__small-add--added';

        var originalText = btn.textContent;
        btn.classList.add(addingClass);
        btn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            btn.classList.remove(addingClass);
            btn.classList.add(addedClass);
            btn.textContent = 'Added \u2713';

            setTimeout(function () {
              btn.classList.remove(addedClass);
              btn.textContent = originalText;
            }, 2000);

            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                data: {
                  itemCount: cart.item_count,
                  source: 'tpc-collection-upsell'
                }
              }
            }));
          })
          .catch(function () {
            btn.classList.remove(addingClass);
            btn.textContent = originalText;
          });
      });
    });
  }
})();
